import axios from "../../config/axiosConfig";
import {
  PURCHASE_REGISTER_REPORT_REQUEST,
  PURCHASE_REGISTER_REPORT_SUCCESS,
  PURCHASE_REGISTER_REPORT_FAILURE,

  GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST,
  GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS,

  GET_ITEMS_OF_PURCHASE_BILL_REQUEST,
  GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_ITEMS_OF_PURCHASE_BILL_SUCCESS,

  GET_BROKERS_OF_PURCHASE_BILL_REQUEST,
  GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_BROKERS_OF_PURCHASE_BILL_SUCCESS,

  GET_LOTS_OF_PURCHASE_BILL_REQUEST,
  GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE,
  GET_LOTS_OF_PURCHASE_BILL_SUCCESS,

  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST,
  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE,
  GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS,
} from "../types/purchase-report-types";

export const getAllAccountOfPurchaseBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllAccountOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNTS_OF_PURCHASE_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ACCOUNTS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllBrokersOfPurchaseBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_BROKERS_OF_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllBrokersOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BROKERS_OF_PURCHASE_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_BROKERS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllLotsOfPurchaseBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_LOTS_OF_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllLotNoOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_LOTS_OF_PURCHASE_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_LOTS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllItemTypesOfPurchaseBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllItemTypesOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        return null;
      });
    } catch (error) {
      console.error(error);
      return null;
    }
  };
};

export const getAllItemsOfPurchaseBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ITEMS_OF_PURCHASE_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllItemsOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEMS_OF_PURCHASE_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ITEMS_OF_PURCHASE_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllPurchaseBillInvoiceNumberOfPurchasesBill = (commonMaster, page = 1, limit = 50, search = '') => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        page,
        limit,
        search
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/purchase-bill/getAllPurchaseInvoiceNumberOfPurchaseBill", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_PURCHASE_BILLS_INVOICE_NUMBER_OF_PURCHASES_BILL_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getPurchaseRegisterReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PURCHASE_REGISTER_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        // finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params?.fromDate);
      console.log('params.toDate',params?.toDate);
      
      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };
      const data = requestParams; 

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/purchase-bill/getReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.post('/purchase-bill/getReport', data, { params: defaultParams }).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PURCHASE_REGISTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Purchase Register Report:", error);
        dispatch({ type: PURCHASE_REGISTER_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Purchase Register Report:", error);
      dispatch({ type: PURCHASE_REGISTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearPurchaseRegisterReport = () => {
  return async (dispatch) => {
    dispatch({ type: PURCHASE_REGISTER_REPORT_SUCCESS, payload: {} });
  }
}
